import { makeStyles } from '@material-ui/core/styles';

// Inspired by the former Facebook spinners.
const useStylesFacebook = makeStyles((theme) => ({
    container: {
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        // height: '500px',
        // width: '50%',
        textAlign: 'center'
    },

    bottom: {
        color: '#fc6d26',
        // display: 'inline-block',
        // textAlign: 'center'
    },
}));

export default useStylesFacebook